export const BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1200,
  xxl: 1440,
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;
